import { Ref } from 'vue';
import { PaginationResetCallback } from '@/ui/types';
import { updateMultiple } from '@/ui/queryState';
import { checkboxField } from '../form';

export const checkboxFilter = (
  {
    value,
    name,
    label,
    reset,
    hideLabel,
    horizontal,
  }: {
    value: Ref<boolean>;
    name: string;
    label: string;
    reset: PaginationResetCallback;
    hideLabel?: boolean;
    horizontal?: boolean;
  },
) => checkboxField(
  {
    value: value.value,
    name,
    label,
    required: false,
    errors: [],
    disabled: false,
    hideLabel,
    horizontal,
  },
  v => updateMultiple(() => {
    reset();
    value.value = v;
  }, true),
);
